import { AfterViewChecked, Component, OnInit } from "@angular/core";
import { ConfigService } from "@app/core/config.service";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

interface LinkTracking {
  eventName: string;
  cssClass: string;
}

interface Item {
  title: string;
  text: string;
  href: string;
  linkTracking: LinkTracking;
}

@Component({
  selector: "om-list-card",
  templateUrl: "./list-card.component.html",
  styleUrls: ["../default-styling.scss", "./list-card.component.scss"],
})
export class ListCardComponent implements OnInit, AfterViewChecked {
  private allLinksTracked: boolean = false;

  items: Item[];

  constructor(
    private config: ConfigService,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {}

  ngOnInit(): void {
    this.items = [
      {
        title: "Get travel health recommendations",
        text: "Find out what vaccines and meds you need for your trip.",
        href: "/survey/3",
        linkTracking: {
          eventName: "Travel Health Survey Clicked",
          cssClass: "travel-health-recommendations",
        },
      },
      {
        title: "Get FSA/HSA reimbursement",
        text: "Request a prescription for over-the-counter items.",
        href: `${this.config.json.myoneServer}/pt/questionnaire/fsa-hsa-reimbursement`,
        linkTracking: {
          eventName: "FSA/HSA Reimbursement Clicked",
          cssClass: "fsa-hsa-reimbursement",
        },
      },
      {
        title: "Request health record",
        text: "Get records sent to or from One Medical.",
        href: `${this.config.json.myoneServer}/pt/questionnaire/medical-records-release`,
        linkTracking: {
          eventName: "Medical Records Release Clicked",
          cssClass: "request-health-record",
        },
      },
    ];
  }

  ngAfterViewChecked() {
    if (this.items.length > 0 && !this.allLinksTracked) {
      this.items.forEach((item: Item) => {
        this.homePageAnalyticsService.trackListCardLink(
          `om-list-card .${item.linkTracking.cssClass}`,
          item.linkTracking.eventName
        );
      });

      this.allLinksTracked = true;
    }
  }
}
